export const DAMAGE_FORM_MODAL = {
  width: '928px',
  height: '922px',
};

export const OTHER_INPUT_STYLE = {
  height: '40px',
  width: '418px',
  labelHeight: '18px',
  labelPaddingBottom: '4px',
  labelFontWeight: '400',
  color: '#494949',
};

export const STYLE_CHECK_BOX_COLUMN_WRAPPER =
  'w-full flex flex-col gap-y-[4px]';

export const STYLE_CHECK_BOX_HEADER_WRAPPER =
  'text-[#595656] font-[500] text-[11px]';

export const STYLE_TRUCK_STATUS_CHECKBOX_AREA = {
  height: '156px',
};

export const STYLE_CHASSIS_STATUS_CHECKBOX_AREA = {
  height: '156px',
};

export const STYLE_DRIVER_TIRES_CHECKBOX_AREA = {
  height: '90px',
};

export const STYLE_DRIVER_STEER_TIRES_CHECKBOX_AREA = {
  height: '38px',
};

export const STYLE_TRAILER_CHASSIS_TIRES_CHECKBOX_AREA = {
  height: '126px',
};
